import { LightField } from '@/components/glass/LightField'
import { GlassStack } from '@/components/glass/GlassStack'
import { cssVars } from '@/lib/utils'

interface PageHeroProps {
  title: string
  subtitle: string
}

/** Ordine di entrata degli elementi della hero (`.enter`). */
export const enterOrder = (i: number) => cssVars({ '--i': i })

/**
 * Hero delle pagine interne: compatta, perché il contenuto della pagina si veda già al primo sguardo. Abisso con luce
 * liquida e, a destra, il marchio in tre lastre di vetro vere. Stessa altezza qualunque sia la lunghezza del testo.
 */
export function PageHero({ title, subtitle }: PageHeroProps) {
  return (
    <section
      data-surface="dark"
      className="section relative flex min-h-[21rem] items-end overflow-clip pb-12 pt-32 md:min-h-[25rem] md:pb-16"
    >
      <LightField variant="abyss" flow />
      {/* Su mobile le lastre stanno intere dentro lo schermo, in alto a destra; più su e più grandi da tablet in poi. */}
      <GlassStack className="absolute right-2 top-1/2 -translate-y-1/2 [--stack:8.5rem] sm:right-[-1rem] sm:top-[56%] md:[--stack:16rem] lg:right-[6%] lg:[--stack:20rem]" />
      <div className="shell relative">
        <h1 className="t-display enter max-w-4xl" style={enterOrder(1)}>
          {title}
        </h1>
        <p className="t-lead enter mt-5 max-w-xl" style={enterOrder(3)}>
          {subtitle}
        </p>
      </div>
    </section>
  )
}
